import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { setLocalidad, clearLocalidad, setCodigoPostal } from "../actions";

import { fetchCodigosPostales } from "~business/codigoPostalSelector/actions";
import LocalidadSelector from "~business/localidadSelector/LocalidadSelector";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";
import localRepository from "../../../../localRepository";

const useStyles = makeStyles((theme) => ({
  cotizador: {
    flexDirection: "row",
    margin: "auto",
    padding: 8,
    paddingBottom: 100,
    width: "100%",
    maxWidth: 500,
    minHeight: "100vh",
  },
  title: {
    paddingBottom: "16px",
  },
}));

interface CodigoPostal {
  label: string;
  value: string;
}

const useReduxSelector = () => {
  const provinciaId = useMulticotizadorSelector(
    (state) => state.provinciaSelected
  );
  const codigosPostales = useSelector<any, CodigoPostal[]>(
    (state) => state.codigoPostalSelectorReducer.codigosPostales
  );

  return { provinciaId, codigosPostales };
};

const LocalidadStep = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [localidad, setValueLocalidad] = useState<string | null>(null);
  const { provinciaId, codigosPostales } = useReduxSelector();

  useEffect(() => {
    dispatch(clearLocalidad());
  }, [dispatch]);

  useEffect(() => {
    if (codigosPostales && codigosPostales.length === 1)
      dispatch(setCodigoPostal(codigosPostales[0].value));

    if (localidad) {
      dispatch(setLocalidad(localidad));
      localRepository.mostUsedLoc.set({
        label: localidad,
        value: localidad,
        provId: provinciaId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigosPostales]);

  const handleSelection = (event: { target: { value: string } }) => {
    const localidad = event.target.value;
    // Este paso va después del de provincia: `provinciaId` ya está elegida.
    dispatch(fetchCodigosPostales(provinciaId as string, localidad));
    setValueLocalidad(localidad);
  };

  return (
    <>
      <div className={classes.cotizador}>
        <div className={classes.title}>
          <PrimaryTitle label={"¿En qué localidad?"} marginBottom={32} />
        </div>
        <LocalidadSelector
          label={"Ingresá o busca la localidad"}
          onSelected={handleSelection}
          provinciaId={provinciaId}
        />
      </div>
    </>
  );
};

export default LocalidadStep;
